export default __webpack_public_path__ + "static/media/circle.fc7cd3cd.png";